<template>
  <div class="vacancy-mobile__card" :style="{ borderColor: color }">
    <div class="vacancy-mobile__content">
      <div class="vacancy-mobile__title">{{ title }}</div>
      <div><small>{{ vacancy_status !== 1 ? 'Vaga já Finalizada' : '' }}</small></div>
      <span v-html="subDesc"></span>
      <div
        v-if="
          vacancy_published_at.length > 0 || talent_applicated_at.length > 0
        "
        class="vacancy-mobile__created"
      >
        <p>
          Vaga aberta em  {{vacancy_published_at}}
        </p>
      </div>
    </div>
    <div class="vacancy-mobile__buttons">
      <div
        class="vacancy-mobile__button-outline"
        :style="{ color: color, borderColor: color }"
        @click="()=> {
          $router.push({
            name: 'vacancy-detail',
            params: { vacancy, isOpen, isSimilar: true}
          });
          trackClick(vacancy);
        }
        "
      >
        Detalhes da Vaga
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vSelect from "vue-select";
import get from 'lodash/get';

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    vacancy: {
      type: Object,
      required: true
    },
    application: {
      type: Object,
      required: false
    }
  },
  data: () => ({
      show_details: false,
      popupActive: false,
      isForms: false,
      unSubscribe: "",
      unsubscribeOptions: [
        "Não quero justificar",
        "Recebi uma outra proposta",
        "Me candidatei na vaga errada",
        "Tive problemas no processo seletivo",
        "Outro"
      ]
    }),
    computed: {
    ...mapState("company", ["company"]),

    color() {
      if(this.vacancy_status === 1)
        return "#8777D9";
      else
        return "#cecece";
    },

    title() {
      return this.vacancy !== undefined && this.vacancy.hasOwnProperty("title")
        ? this.vacancy.title
        : "";
    },

    vacancy_status() {
      if (this.vacancy === undefined) return "";
      if (this.vacancy.hasOwnProperty("vacancy_status_id")) return  this.vacancy.vacancy_status_id;
      if (this.vacancy.hasOwnProperty("status") && this.vacancy.hasOwnProperty("id")) return  this.vacancy.status.id;
    },

    description() {
      return this.vacancy != undefined &&
        this.vacancy.hasOwnProperty("description")
        ? this.vacancy.description
        : "";
    },

    vacancy_published_at() {
      return this.vacancy != undefined &&
        this.vacancy.hasOwnProperty("published_at")
          ? this.vacancy.published_at
          : "";
    },

    talent_applicated_at() {
      return this.vacancy != undefined &&
        this.vacancy.hasOwnProperty("applications") &&
        this.vacancy.applications.length > 0
        ? new Date(this.vacancy.applications[0].created_at).toLocaleString(
            "pt-BR"
          )
        : "";
    },

    talent_withdrawal(){
      return this.vacancy != undefined &&
        this.vacancy.hasOwnProperty("applications") &&
        this.vacancy.applications.length > 0
        ? this.vacancy.applications[0].application_withdrawal_id
        : null
    },

    showLocation() {
      return (
        this.vacancy &&
        this.vacancy.show_location &&
        this.vacancy.show_location == 1
      );
    },

    subDesc() {
      const subDesc = [];
        
      if (get(this.vacancy, 'company.name')) {
        subDesc.push(`<strong>${get(this.vacancy, 'company.name') }</strong>`)
      }

      if (this.showLocation) {
        if (get(this, 'remote.id') === 2) {
            subDesc.push("Remoto");
        } else if(get(this.vacancy, 'location')) {
            subDesc.push(get(this.vacancy, 'location', ''))
        }
      } else {
        subDesc.push("Local Não Divulgado");
      }

      if (get(this, 'vacancy.show_regime')) {
          subDesc.push(get(this.vacancy, 'regime.description', ''))
      }

      return subDesc.join(" | ");
    },
  },
  methods: {
    trackClick(vacancy) {
      window.woopra.track('similar-detail-click', {
        isMobile: true,
        vacancy,
      });
    },
    handleRedirectToApplicationProcess() {
      const { params } = this.$router.history.current;

      this.$router.push({
        name: "application-process",
        params: {
          ...params,
          step_id: this.step_id,
          vacancy_id: this.vacancy.id
        }
      });
    },
    async doApplication() {
      try {
        this.popupActive = false;
        this.$vs.loading();

        const body = {
          application_id: this.vacancy.applications[0].id,
          description: this.unSubscribe
        };

        const response = await this.$http.post(
          `/api/v2/applications-withdrawal/`,
          body
        );

        if (response.status == 200) {
          this.$vs.notify({
            title: "Candidatura removida com sucesso!",
            text: response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });
        }
        this.$vs.loading.close();
        if (this.isForms) {
          this.handleRedirectToApplicationProcess();
        } else {
          this.$router.back();
        }
      } catch (error) {
        this.popupActive = false;
        this.$vs.loading.close();

        this.$vs.notify({
          title: "Falha ao Remover candidatura",
          text:
            "Falha ao realizar o procedimento contate a nossa equipe de suporte",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      }
    },
  },
  components: {
    "v-select": vSelect
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/talent/components/vacancymobilecard.scss";
</style>
